
import AuthenticationService from './AuthenticationService';

export {default as AuthenticationService} from './AuthenticationService';
export default new AuthenticationService();
